var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{directives:[{name:"tooltip",rawName:"v-tooltip",value:({ content: _vm.text, placement: _vm.placement, trigger: 'hover click' }),expression:"{ content: text, placement: placement, trigger: 'hover click' }"}],tag:"component",staticClass:"Tooltip"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }